import { userAuthInfoPresent } from '../helpers/authHelpers'
import { routes } from '../components/router/routes'
import { userPasswordLogin, changePassword } from '../helpers/restHelpers'
import { removeTokenKey } from '../helpers/dbHelpers'

export const userAuthInfoPresentAction = (history) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'AUTHENTICATE' })
        if (userAuthInfoPresent()) {
            if (!getState().user.authenticated)
                dispatch({ type: 'AUTHENTICATE_SUCCESS' })
            resolve()
        } else {
            dispatch({ type: 'AUTHENTICATE_FAILURE' })
            reject()
        }
    })

export const userPasswordLoginAction =
    (username, password, history) => (dispatch, getState) =>
        new Promise((resolve, reject) => {
            dispatch({ type: 'AUTHENTICATE' })
            userPasswordLogin(username, password)
                .then((response) => {
                    dispatch({ type: 'AUTHENTICATE_SUCCESS' })
                    resolve(response)
                })
                .catch((error) => {
                    dispatch({ type: 'AUTHENTICATE_FAILURE' })
                    reject(error)
                })
        })

export const logOutAction = (history) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        removeTokenKey()
        dispatch({ type: 'LOG_OUT' })
        if (history) history.push(routes.logIn.path)
        else window.location.reload()
    })

export const changePasswordAction =
    (passwordOld, passwordNew) => (dispatch, getState) =>
        new Promise((resolve, reject) => {
            dispatch({ type: 'PASSWORD_CHANGE' })
            changePassword(passwordOld, passwordNew)
                .then((response) => {
                    dispatch({ type: 'PASSWORD_CHANGE_SUCCESS' })
                    resolve(response)
                })
                .catch((error) => {
                    dispatch({ type: 'PASSWORD_CHANGE_FAILURE' })
                    reject(error)
                })
        })
